/* eslint-disable react/jsx-no-duplicate-props */
import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { Header, Grid, GridRow, GridColumn } from 'semantic-ui-react';
import { Button } from 'semantic-ui-react';
import { Activity } from '../../app/models/activity';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../app/stores/store';
import QuickScanModal from './QuickScanModal';
import DynamicTableFrontEnd from '../DynamicTable/DynamicTableFrontEnd';
// import { WorkFlowTask } from "../../app/models/template";
// import { useParams } from "react-router-dom";
// import agent from "../../app/api/agent";
// import TaskFormModal from "../MediaAssets/Details/TaskFormModal";
import { Message } from 'semantic-ui-react';
import _ from 'lodash';
import { toast } from 'react-toastify';
import DynamicTableComponent from '../DynamicTable/DynamicTableComponent';
import UnauthorizedMessage from '../UnauthorizedMessage';
// import agent from "../../app/api/agent";

function QuickScan() {
  // route
  // const params = useParams();
  const {
    reportStore,
    userStore,
    dashboardStore,
    activityStore,
    commonStore,
    QuickScanStore,
  } = useStore();

  const { userReadableDateFormat } = commonStore;
  const {
    activitiesByDate,
    loadActivitiesPagination,
    loadCountAssetTable,
    ActivityQuickscanIs,
  } = activityStore;
  const { loadingDataReport } = reportStore;
  const {
    // quickScanActivityId,
    quickScanbarcodeInfo,
    barcodeinfodetailApi,
    QuickScanStatusChanger,
    // quickScanTaskInfo,
    // quickScanSubtaskinfo,
    QuickscanshowBtn,
    // quickScanTask_subtask,
    QuickscancheckboxChecker,
    quickscanUnorderlist,
    // QuickscanTaskModel,
    // barcodeInfoLocaltoShow,
    // QuickscanAllData
    // Quickscantask_subtaskTrigger,
    Quickscanasstabledata,
    // QuickscanCheckboxer1,
    barcodeInvetoryDatagetter,
    WithoutbarcodeInvetoryData,
    quickScanshowButton,
    Quickscantask_subtaskTrigger,
  } = QuickScanStore;
  const { getUsers } = userStore;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [barCodeInfo, setBarcodeInfo] = useState<any[] | []>([]);
  const [current_subtaskdata, setcurrent_subtaskdata] = useState('');
  const [current_taskdata, setcurrent_taskdata] = useState('');
  const [current_tasksubtaskchekcer, setCurrent_tasksubtaskchekcer] =
    useState(false);
  const [inventorydata, setInventorydata] = useState<boolean>(true);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [scannedCodes, setScannedCodes] = useState<string[]>([]);
  const [itemNotFound, setItemNotFound] = useState<string[]>([]);
  const [receivingOrDelivery, SetReceivingOrDelivery] = useState<string>('');
  // const [unOrderItems, setUnOrderItems] = useState<string[]>([]);

  // eslint-disable-next-line
  // const activityId: any = activityStore.selectedActivity;

  // taskform model start

  // const []
  // const [showTasksModal, setShowTasksModal] = useState(false);
  // const [selectedSubTask, setSelectedSubTask] = useState({});
  // const [eleModalTitle, setEleModalTitle] = useState("");
  // const [subTaskIdNo, setSubTaskIdNo] = useState("");
  // const [listTaskItems, setListTaskItems] = useState([]);
  // const [sortedListItems, setSortedListItems] = useState<any[] | []>([]);
  // const [taskId, setTaskId] = useState<any[] | []>([]);
  // const [currSubTaskData, setCurrSubTaskData] = useState<any[] | []>([]);
  // const [taskTitleName, setTaskTitleName] = useState("");
  const [viewpageModel, setViewpageModel] = useState(false);
  // const [unorderData,setUnorderData] = useState([])
  /// taskform model end

  useEffect(() => {
    if (Quickscanasstabledata.rowData !== '') {
      quickScanshowButton(Quickscanasstabledata?.rowData['status']);
      let data = Quickscanasstabledata?.rowData['current_task'];
      setcurrent_taskdata(data);
      setcurrent_subtaskdata(Quickscanasstabledata?.rowData['current_subtask']);
      setCurrent_tasksubtaskchekcer(true);
      // eslint-disable-next-line
    }
    if (WithoutbarcodeInvetoryData.length === 0) {
      empttasksubtask();
    }
    // eslint-disable-next-line
  }, [pageNumber, Quickscanasstabledata]);

  useEffect(() => {
    empttasksubtask();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    activityStore.QuickscanCheckboxisChekcer(true);
    // eslint-disable-next-line
    // eslint-disable-next-line
  }, [ActivityQuickscanIs]);

  useEffect(() => {
    if (dashboardStore.dashboard.setTagTablePageNumber === 1) {
      // setCurrent_tasksubtaskchekcer(false)
      setPageNumber(dashboardStore.dashboard.setTagTablePageNumber);
    }
  }, [dashboardStore.dashboard.setTagTablePageNumber]);

  useEffect(() => {
    if (
      viewpageModel &&
      quickscanUnorderlist &&
      quickscanUnorderlist.length !== null
    ) {
      setViewpageModel(false);
      setTimeout(() => {
        quickscanUnorderlist.length = 0;
        // setCurrent_tasksubtaskchekcer(false);
        // barcodeInfoLocaltoShow();
      }, 1000);
    }
    // eslint-disable-next-line
  }, [viewpageModel]);
  useEffect(() => {
    if (
      quickscanUnorderlist.length === 0 &&
      quickscanUnorderlist.length !== null
    ) {
      quickscanUnorderlist.length = 0;
      setViewpageModel(false);
    }
    // barcodeInfoLocaltoShow();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (inventorydata === true) {
      dashboardStore.updateCountOrderMenu(userStore?.user?.id);
      loadActivitiesPagination(1, userStore?.user?.id, 20);
      WithoutbarcodeInvetoryData.length = 0;
    }
    // eslint-disable-next-line
  }, [inventorydata, viewpageModel]);

  // useEffect(()=>{
  //   if((eleModalTitle !== "") && (eleModalTitle !== undefined)){
  //     reportStore.QuickscanTaskModel = true;
  //   }
  // },[eleModalTitle])
  useEffect(() => {
    if (quickScanbarcodeInfo) {
      quickScanbarcodeInfo.filter((item: any) => {
        return delete item.orders;
      });
      setBarcodeInfo(quickScanbarcodeInfo);
    }
    // eslint-disable-next-line
  }, [quickScanbarcodeInfo, QuickscanshowBtn, pageNumber]);
  // useEffect(() => {
  //   tiggerSubtasksModal();
  //   // }

  //   // eslint-disable-next-line
  // }, [
  //   viewpageModel,
  //   QuickscanTaskModel,
  //   quickScanSubtaskinfo,
  //   quickScanTaskInfo,
  //   Quickscantask_subtaskTrigger,
  // ]);

  useEffect(() => {
    let availableItems: string[] = scannedCodes;
    quickscanUnorderlist?.forEach((code: string) => {
      if (availableItems.includes(code)) {
        availableItems = availableItems.filter((itemCode) => itemCode !== code);
      }
    });
    quickScanbarcodeInfo?.filter(
      (item: any, index: number) =>
        quickScanbarcodeInfo.indexOf(item) === index,
    );

    quickScanbarcodeInfo?.forEach((itemInfo: any) => {
      if (availableItems?.includes(itemInfo?.physical_sensor_barcode)) {
        availableItems = availableItems.filter(
          (itemCode) => itemCode !== itemInfo?.physical_sensor_barcode,
        );
      }
    });
    const uniqueArray = Array.from(new Set(availableItems));
    setItemNotFound(uniqueArray);
    // setUnOrderItems(quickscanUnorderlist);
  }, [quickScanbarcodeInfo, quickscanUnorderlist, scannedCodes]);

  useEffect(() => {
    dashboardStore.updateCountOrderMenu(userStore.user!.id);
    // activityStore.loadActivitiesPagination(1, userStore?.user!.id, 10);
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  const userID = userStore.user?.id !== undefined ? userStore.user?.id : '';
  // eslint-disable-next-line
  const tableData: Activity[] = [];
  activitiesByDate.forEach((a: any) => {
    delete a?.synopsis;
    tableData?.push({
      ...a,

      movementdate: userReadableDateFormat(a.movementdate),
      movement_Time: userReadableDateFormat(a.movement_Time),
      maintenance: userReadableDateFormat(a.maintenance),
      receivingdate: userReadableDateFormat(a.receivingdate),
      status_Time: userReadableDateFormat(a.status_Time),
      itemCreatedAt: userReadableDateFormat(a.itemCreatedAt),
    });
  });
  const removeCol = '';

  const assettable = JSON.parse(JSON.stringify(tableData));
  assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  if (loadingDataReport) return <LoadingComponent />;
  const tableData2: any[] = [];
  // eslint-disable-next-line array-callback-return
  getUsers?.map((a) => {
    tableData2?.push({
      key: a?.id,
      text: a?.displayName,
      value: a,
    });
  });

  async function submitHandler() {
    setInventorydata(false);
    setCurrent_tasksubtaskchekcer(false);
    setcurrent_taskdata('');
    setcurrent_subtaskdata('');
    var input = document.getElementById(
      'myInputQuickscan',
    ) as HTMLTextAreaElement;
    let value = input.value;
    // setScannedBarcode(value);
    barcodeinfodetailApi(value);

    let barcodeDetails = value.split('\n');
    barcodeDetails.pop();

    setScannedCodes(barcodeDetails);
    setOpenModal(false);
  }
  const paginateFunction = (e: number) => {
    // setCurrent_tasksubtaskchekcer(false)
    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      activityStore.searchListItems(
        dashboardStore.dashboard.searchfilterparams,
        e,
        20,
      );
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      activityStore.sortListItems(
        dashboardStore.dashboard.orderName,
        dashboardStore.dashboard.orderData,
        e,
        5,
      ); //api call
    } else {
      loadActivitiesPagination(e, userID, 20);
    }
    dashboardStore.setTagPageNumFunc(e);
    setPageNumber(e);
    if (WithoutbarcodeInvetoryData.length === 0) {
      empttasksubtask();
      setCurrent_tasksubtaskchekcer(false);
      setcurrent_taskdata('');
      setcurrent_subtaskdata('');
      quickScanshowButton('clear');
    } else {
      setCurrent_tasksubtaskchekcer(false);
      setcurrent_taskdata('');
      setcurrent_subtaskdata('');
      quickScanshowButton('clear');
    }
  };
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };
  const checkBoxClickedInventoryandQuickScan = (
    rowData: any,
    dataClick: any,
    index: number,
  ) => {
    setCurrent_tasksubtaskchekcer(dataClick.checked);
    setcurrent_taskdata(rowData.current_task);
    setcurrent_subtaskdata(rowData.current_subtask);
    dataClick?.checked !== true && (QuickscancheckboxChecker.length = 0);
    let bardcodes = [...activityStore?.ActivityQuickscanData];
    bardcodes[index]['isChecked'] = dataClick.checked;
    // bardcodes[index]["isDisabled"] = false
    //  status api

    let params = {
      typeId: rowData.typeid,
      elementId: rowData.elementtypeid,
      currentTask: rowData.current_task,
      currentSubtask: rowData.current_subtask,
      status: rowData.status,
    };
    if (dataClick?.checked === true) {
      quickScanshowButton(rowData['status']);
      if (rowData['isReceiving'] === true) {
        SetReceivingOrDelivery('receiving');
      } else if (rowData['isDelivery'] === true)
        SetReceivingOrDelivery('delivery');
      else {
        toast.info('Items with No Order. Status cannot be changed.');
        empttasksubtask();
        WithoutbarcodeInvetoryData.length = 0;
      }
    } else {
      quickScanshowButton('notData');
    }
    barcodeInvetoryDatagetter(params, dataClick?.checked);
    for (let i = 0; i < bardcodes?.length; i++) {
      try {
        if (assettable?.[i]?.isChecked !== undefined) {
          assettable[i].isChecked = false;
        }
      } catch (error) {
        console.log('An error occurred while setting isChecked:', error);
      }
      if (dataClick.checked) {
        if (
          rowData.status === bardcodes[i].status &&
          rowData.current_task === bardcodes[i].current_task &&
          rowData.current_subtask === bardcodes[i].current_subtask &&
          rowData.type === bardcodes[i].type &&
          rowData.element === bardcodes[i].element &&
          rowData.current_user === barCodeInfo[i].current_user
        ) {
          if (!Object.keys(assettable[i] as any).includes('isChecked')) return;
          (assettable?.[i] as any)['isChecked'] = true;
          (assettable?.[i] as any)['isDisabled'] = false;
          (activityStore?.ActivityQuickscanData[i] as any)['isChecked'] = true;
          (activityStore?.ActivityQuickscanData[i] as any)['isDisabled'] =
            false;
          QuickScanStore?.QuickscancheckboxChecker?.push(
            activityStore?.ActivityQuickscanData[i],
          );
        } else {
          (activityStore?.ActivityQuickscanData[i] as any)['isChecked'] = false;
          (activityStore?.ActivityQuickscanData[i] as any)['isDisabled'] = true;
          if (!Object.keys(assettable[i] as any).includes('isChecked')) return;
          (assettable?.[i] as any)['isChecked'] = false;
          (assettable?.[i] as any)['isDisabled'] = true;
          QuickScanStore?.QuickscancheckboxChecker?.push(
            activityStore?.ActivityQuickscanData[i],
          );
        }
      } else {
        (activityStore?.ActivityQuickscanData[i] as any)['isChecked'] = false;
        (activityStore?.ActivityQuickscanData[i] as any)['isDisabled'] = false;
        if (!Object.keys(assettable[i] as any).includes('isChecked')) return;
        (assettable?.[i] as any)['isChecked'] = false;
        (assettable?.[i] as any)['isDisabled'] = true;
      }
    }
    const ids = QuickScanStore.QuickscancheckboxChecker.map((o) => o.id);
    QuickScanStore.QuickscancheckboxChecker =
      QuickScanStore.QuickscancheckboxChecker.filter(
        ({ id }, index) => !ids.includes(id, index + 1),
      );
    if (dataClick.checked !== true) {
      setCurrent_tasksubtaskchekcer(false);
      setcurrent_taskdata('');
      setcurrent_subtaskdata('');
      quickScanshowButton('clear');
    }
    // ActivityQuickscanData
  };
  const empttasksubtask = () => {
    setCurrent_tasksubtaskchekcer(false);
    setcurrent_taskdata('');
    setcurrent_subtaskdata('');
    quickScanshowButton('clear');
  };
  const buttonstartproject = (e: SyntheticEvent) => {
    // quickScanshowButton("Started");
    inventorydata ? InventoryStatus(1) : QuickScanStatusChanger('1', 'Started');
    setViewpageModel(true);
    empttasksubtask();
  };
  const openCompleted = (e: SyntheticEvent) => {
    // quickScanshowButton("Completed");
    inventorydata
      ? InventoryStatus(2)
      : QuickScanStatusChanger('2', 'Complete');
    setViewpageModel(true);
    empttasksubtask();
  };

  const openHold = (e: SyntheticEvent) => {
    // quickScanshowButton("Hold");
    inventorydata ? InventoryStatus(3) : QuickScanStatusChanger('3', 'Hold');
    setViewpageModel(true);
    empttasksubtask();
  };

  const openResume = (e: SyntheticEvent) => {
    // quickScanshowButton("Resume");
    inventorydata ? InventoryStatus(4) : QuickScanStatusChanger('4', 'Resume');
    setViewpageModel(true);
    empttasksubtask();
  };
  const openReject = (e: SyntheticEvent) => {
    // quickScanshowButton("rejected");
    inventorydata
      ? InventoryStatus(5)
      : QuickScanStatusChanger('5', 'rejected');
    setViewpageModel(true);
    empttasksubtask();
  };

  const openResolve = (e: SyntheticEvent) => {
    // quickScanshowButton("Complete");
    inventorydata
      ? InventoryStatus(7)
      : QuickScanStatusChanger('7', 'Resolved');
    setViewpageModel(true);
    empttasksubtask();
  };

  const InventoryStatus = (status: number) => {
    const end = WithoutbarcodeInvetoryData.length;
    for (let i = 0; i < end; i++) {
      QuickScanStore?.InventoryLoopStatusChanger(
        WithoutbarcodeInvetoryData[i],
        status,
        receivingOrDelivery,
      );
    }
  };
  const checkBoxClickedAllocateandQuickScan = (
    rowData: any,
    dataClick: any,
    index: number,
  ) => {
    setCurrent_tasksubtaskchekcer(dataClick.checked);
    setcurrent_taskdata(rowData.current_task);
    setcurrent_subtaskdata(rowData.current_subtask);
    QuickscancheckboxChecker.length = 0;
    let bardcodes = [...QuickScanStore?.quickScanbarcodeInfo];
    bardcodes[index]['isChecked'] = dataClick.checked;
    if (dataClick?.checked === true) {
      quickScanshowButton(rowData['status']);
    } else {
      quickScanshowButton('notData');
    }
    if (rowData.isReceiving === false && rowData.status === 'NA') {
      toast.success('No Active Workflow');
    } else {
      for (let i = 0; i < bardcodes?.length; i++) {
        if (dataClick.checked) {
          if (
            rowData.status === bardcodes[i].status &&
            rowData.current_task === bardcodes[i].current_task &&
            rowData.current_subtask === bardcodes[i].current_subtask &&
            rowData.type === bardcodes[i].type &&
            rowData.element === bardcodes[i].element &&
            rowData.current_user === barCodeInfo[i].current_user
          ) {
            (QuickScanStore?.quickScanbarcodeInfo[i] as any)['isChecked'] =
              true;
            (QuickScanStore?.quickScanbarcodeInfo[i] as any)['isDisabled'] =
              false;
            QuickScanStore.QuickscancheckboxChecker.push(
              QuickScanStore?.quickScanbarcodeInfo[i],
            );
          } else {
            (QuickScanStore?.quickScanbarcodeInfo[i] as any)['isChecked'] =
              false;
            (QuickScanStore?.quickScanbarcodeInfo[i] as any)['isDisabled'] =
              true;
          }
        } else {
          (QuickScanStore?.quickScanbarcodeInfo[i] as any)['isChecked'] = false;
          (QuickScanStore?.quickScanbarcodeInfo[i] as any)['isDisabled'] =
            false;
        }
      }
    }

    if (dataClick.checked !== true) {
      setCurrent_tasksubtaskchekcer(false);
      setcurrent_taskdata('');
      setcurrent_subtaskdata('');
    }
    // activityStore.collectMetaData(QuickscancheckboxChecker[0]?.id);
  };

  const classNameForQuickScan = (isDisabled: boolean) => {
    if (isDisabled) {
      return 'disable-for-quick-scan';
    }
    return 'enable-for-quick-scan';
  };

  // const tiggerSubtasksModal = () => {
  //   setShowTasksModal(true)
  //   quickScanSubtaskinfo.length > 0 &&
  //     setSelectedSubTask(quickScanSubtaskinfo[0]);
  //   // let quickScanSubtaskinfo1 = quickScanSubtaskinfo.subTaskName

  //   let modelTitle =
  //     quickScanTaskInfo[0]?.taskName +
  //     "/" +
  //     quickScanSubtaskinfo?.[0]?.subTaskName;
  //   setEleModalTitle(modelTitle);
  //   setSubTaskIdNo(quickScanSubtaskinfo?.[0]?.subTaskId);
  //   setListTaskItems(quickScanTask_subtask[0]?.data.tasks);
  //   setSortedListItems(quickScanTask_subtask?.[0]?.data);
  //   setTaskId(quickScanTaskInfo[0]?.taskId);
  //   setCurrSubTaskData(quickScanSubtaskinfo?.[0]);
  //   setTaskTitleName(quickScanTaskInfo?.[0]?.taskName);

  //   // if(quickScanTaskInfo?.[0]?.taskName) activityStore.collectMetaData(quickScanTaskInfo?.[0]?.taskName);
  //   if (quickScanSubtaskinfo?.[0]?.subTaskId)
  //     QuickScanStore.QuickscanTaskModel = true;
  // };
  // const completeLastSubtask = async () => {
  //   let taskIndex = 0,
  //     subTaskIndex = 0;
  //   const listTaskItemsDup: WorkFlowTask[] = Object.assign([], listTaskItems);
  //   let taskIndexTemp = taskIndex || 0;
  //   let subTaskIndexTemp = subTaskIndex || 0;

  //   let payload = {
  //     templateId: quickScanTask_subtask?.[0]?.data.templateId || "",
  //     itemId: (params as any)?.id,
  //     taskId: listTaskItemsDup[taskIndexTemp].taskId,
  //     subtaskId:
  //       listTaskItemsDup[taskIndexTemp].subTasks[subTaskIndexTemp].subTaskId,
  //   };
  //   let p1 = new Promise(async (resolve) => {
  //     await agent.TaskFormTaskServices.updateCompleteSubTask(payload);
  //     resolve("");
  //   });
  //   p1.then(() => {
  //   }).catch((error) => {
  //     console.error(error);
  //   });
  // };
  // const closeTaskFormModal = (e: boolean) => {
  //   setShowTasksModal(e);
  //   setViewpageModel(e);
  // };

  // const hideSubtask = (data: boolean) => {
  //   setShowTasksModal(data);
  //   setViewpageModel(data);
  // };

  // if (!loadActivitiesPagination || loadCountAssetTable)
  //   return (
  //     <div style={{ height: "40vh" }}>
  //       {" "}
  //       <LoadingComponent />{" "}
  //     </div>
  //   );

  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        (commonStore.filterModeTwo?.includes('AVIB02') ||
          commonStore.filterModeZero?.includes('AVIB02')) && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('AVIB02') && (
        <>
          {openModal && (
            <QuickScanModal
              open={openModal}
              setOpen={setOpenModal}
              submitHandler={submitHandler}
            />
          )}

          {/* {viewpageModel && QuickScanStore.QuickscanTaskModel ? (
        <TaskFormModal
              taskname={taskTitleName}
              showTasksModal={showTasksModal}
              closeTaskFormModal={closeTaskFormModal}
              assignedUsers={[]}
              selectedSubTask={selectedSubTask}
              eleModalTitle={eleModalTitle}
              subTaskIdNo={subTaskIdNo}
              completeSubtask={completeSubtask}
              taskData={sortedListItems}
              taskId={taskId}
              currSubTaskData={currSubTaskData}
              hideSubtask={hideSubtask} 
              physical_sensor_barcode={""} 
              filterRolesHandler={undefined} 
              workflowHistoryHandler={() => {}}
              // workflowHistoryHandler={function (result: { Description: string; Values: string; }[]): void {
              //        throw new Error("Function not implemented.");
              // } }    
        />
      ) :
      null} */}
          <Header
            style={{ marginLeft: '28px' }}
            icon="archive"
            size="huge"
            dividing
            as="h1"
            content={
              (userLanguage[0].QuickScan?.AUH01 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            sub
            color="grey"
          />
          <Grid>
            <GridRow
              style={{
                gridGap: '3px',
                padding: '25px',
                justifyContent: 'end',
              }}
            >
              <GridColumn
                style={{
                  display: 'flex',
                  flexDirection: 'row',

                  width: 'max-content',
                }}
              >
                {current_tasksubtaskchekcer === true ? (
                  <strong
                    style={{
                      fontSize: '16px',
                      marginTop: '10px',
                      marginRight: '10px',
                    }}
                  >
                    Current Task:
                    <span style={{ margin: '0px 10px', color: '#858585' }}>
                      {current_taskdata}
                    </span>
                    Current SubTask:
                    <span style={{ margin: '0px 10px', color: '#858585' }}>
                      {' '}
                      {current_subtaskdata}{' '}
                    </span>
                  </strong>
                ) : (
                  <p></p>
                )}

                {QuickscanshowBtn.start === true && (
                  <Button
                    onClick={(e) => buttonstartproject(e)}
                    color="blue"
                    style={{ marginRight: '5px' }}
                  >
                    Start
                  </Button>
                )}
                {QuickscanshowBtn.complete === true && (
                  <Button.Group floated="right">
                    <Button
                      color="blue"
                      style={{ marginRight: '5px' }}
                      onClick={(e) => openCompleted(e)}
                    >
                      {' '}
                      Complete{' '}
                    </Button>
                    <Button.Or />
                    <Button
                      color="yellow"
                      style={{ marginRight: '5px' }}
                      //openHold
                      onClick={(e) => openHold(e)}
                    >
                      {' '}
                      Hold
                    </Button>
                    <Button.Or />
                    <Button
                      color="red"
                      style={{ marginRight: '5px' }}
                      onClick={(e) => openReject(e)}
                    >
                      Reject
                    </Button>
                  </Button.Group>
                )}

                {QuickscanshowBtn.Resume === true && (
                  <Button
                    style={{ marginRight: '5px' }}
                    onClick={(e) => openResume(e)}
                  >
                    {' '}
                    Resume{' '}
                  </Button>
                )}
                {QuickscanshowBtn.Reject === true && (
                  <Button
                    style={{ marginRight: '5px' }}
                    onClick={(e) => buttonstartproject(e)}
                  >
                    {' '}
                    Rework{' '}
                  </Button>
                )}
                {QuickscanshowBtn.Resolve === true && (
                  <Button
                    style={{ marginRight: '5px' }}
                    color="green"
                    onClick={(e) => openResolve(e)}
                  >
                    {' '}
                    Resolve{' '}
                  </Button>
                )}

                {commonStore.filterModeTwo?.includes('AUB01') ? (
                  <></>
                ) : (
                  <Button
                    onClick={() => setOpenModal(true)}
                    primary
                    disabled={commonStore.filterModeZero?.includes('AUB01')}
                  >
                    {
                      (userLanguage[0].QuickScan?.AUB01 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Button>
                )}
              </GridColumn>
            </GridRow>
          </Grid>
          <div style={{ position: 'relative', height: '50vh' }}>
            {' '}
            {/* (!loadActivitiesPagination||loadCountAssetTable || Quickscantask_subtaskTrigger ) ? 
<LoadingComponent />   :( */}
            {inventorydata === true ? (
              <DynamicTableComponent
                data={assettable}
                name={'QuickScan'}
                actiontype={''}
                pageFunc={paginateFunction}
                pageNumData={pageNumber}
                searchFuncData={searchFunction}
                classNameForQuickScan={classNameForQuickScan}
                checkBoxClickedInventoryandQuickScan={
                  checkBoxClickedInventoryandQuickScan
                }
                loading={
                  !loadActivitiesPagination ||
                  loadCountAssetTable ||
                  Quickscantask_subtaskTrigger
                }
              />
            ) : (
              <DynamicTableFrontEnd
                data={barCodeInfo}
                name={'QuickScan'}
                actiontype={''}
                classNameForQuickScan={classNameForQuickScan}
                checkBoxClickedAllocateandQuickScan={
                  checkBoxClickedAllocateandQuickScan
                }
                loading={
                  !loadActivitiesPagination ||
                  loadCountAssetTable ||
                  Quickscantask_subtaskTrigger
                }
              />
            )}
          </div>
          <div>
            <br />
            {!!quickscanUnorderlist.length && (
              <Message style={{ marginTop: '280px' }}>
                <Message.Header>
                  <p style={{ marginBottom: '12px' }}>
                    Scanned barcode(s) with no order:
                  </p>
                </Message.Header>

                <Message.Content>
                  {!loadActivitiesPagination || loadCountAssetTable ? (
                    <div style={{ transform: 'translate(0,-5.5vh)' }}>
                      <LoadingComponent />
                    </div>
                  ) : quickscanUnorderlist.length === 0 ? (
                    <p>No Wrong Barcodes</p>
                  ) : (
                    quickscanUnorderlist?.map((data: string, index: number) => {
                      return <p key={index}>{data}</p>;
                    })
                  )}
                </Message.Content>
              </Message>
            )}
          </div>
          {itemNotFound.length ? (
            <Message>
              <Message.Header>
                <p style={{ marginBottom: '12px' }}>Item(s) not found:</p>
              </Message.Header>
              <Message.Content>
                {itemNotFound?.map((barcode: string, index: number) => {
                  return <p key={index}>{barcode}</p>;
                })}
              </Message.Content>
            </Message>
          ) : null}
        </>
      )}
    </>
  );
}

export default observer(QuickScan);
